import useSyncDatesToShow from '@discover-overrides/data/stores/restaurants/hooks/useSyncDatesToShow';
import { type DinerOptions, type PeopleOption } from '@discover-data/stores/hooks/people/options';
import { type RestaurantTagType } from '@discover-data/stores/restaurant/gql/fragments/restaurantTag';
import useSyncDate from './date/useSync';
import useSyncDiscountOnly from './discountOnly/useSync';
import useSyncFavourite from './favourite/useSync';
import useSyncHasLastTable from './hasLastTable/useSync';
import useSyncPeople from './people/useSync';
import useSyncRegularOnly from './regularOnly/useSync';
import useSyncSession from './session/useSync';
import useSyncSort from './sort/useSync';
import useSyncFeaturedSortVariant from './sort/useSyncFeaturedSortVariant';
import useSyncSuburb from './suburb/useSync';
import useSyncTagIds from './tagIds/useSync';
import useSyncTimes from './times/useSync';

export type UseSyncInputsProps = {
  tags: RestaurantTagType[];
  peopleOptions?: DinerOptions;
  minDiners?: PeopleOption | null;
  maxDiners?: PeopleOption | null;
};

/**
 * Sync the inputs from various sources to the restaurant store.
 */
export default function useSyncInputs({
  tags,
  peopleOptions,
  minDiners,
  maxDiners,
}: UseSyncInputsProps) {
  useSyncDatesToShow();

  // filters from the router
  useSyncDate();
  useSyncDiscountOnly();
  useSyncFavourite();
  useSyncRegularOnly();
  useSyncPeople(peopleOptions, minDiners, maxDiners);
  useSyncSession();
  useSyncSort();
  useSyncFeaturedSortVariant();
  useSyncSuburb();
  useSyncTagIds(tags);
  useSyncHasLastTable();
  useSyncTimes();
}
